import React, { Component } from "react";

import { Box, Button, Typography } from "@mui/material";

import schema from "./schema";
import datalink from "./datalink";

import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { VStack, HStack } from "Components/LabIZO/Stackizo";
import { Accessor, ColorX, Authority } from "static";

class Answer extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      title: "GENERIC ANSWERS",
      serverSidePagination: false,
      base: {
        title: "Generic Answers",
        exportDoc: "Generic_Answers",
        schema: schema,
        reqAuth: "Answer",

        tablizo: {
          columnsToolbar: true,
          filterToolbar: true,
          densityToolbar: true,
          exportToolbar: false,
          showSelector: true,
        },

        Connect: {
          DBInfo: datalink.Request.DBInfo,
          List: datalink.Request.List,
          schema: schema.Table,
        },

        operations: {
          Add: {
            title: "Add Answer",
            url: datalink.Request.Add,
            success: "Answer Added Successfully",
            fail: "Answer Add Failed: ",
            schema: schema.Add,
            buttons: ["Clear", "Submit"],
            onSubmit: "Add",
          },
          Delete: {
            title: "Delete this Answer?",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.Delete,
            success: "Answer Deleted Successfully.",
            fail: "Answer Delete Failed: ",
            onSubmit: "Delete",
          },
          Edit: {
            title: "Edit Answer ",
            url: datalink.Request.Edit,
            success: "Answer Edited Successfully",
            fail: "Answer Edit Failed: ",
            schema: schema.Edit,
            buttons: ["Revert", "Submit"],
            onSubmit: "Edit",
          },
          Info: {
            title: "Answer",
            schema: schema.Info,
            readOnly: true,
          },
          DeleteBulk: {
            title: (n) => "Delete these " + n + " Answers?",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.DeleteBulk,
            success: "Answers Deleted Successfully.",
            fail: "Answers Delete Failed: ",
            onSubmit: "DeleteBulk",
          },
          Export: {
            url: datalink.Request.Export,
            schema: schema.Export,
          },
          Import: {
            title: "Answer Import",
            content: "(File size cannot exceed 10MB, only accept .xlsx and .xls)",
            url: datalink.Request.Import,
            success: "Answer Imported Successfully.",
            fail: "Answer Import Failed: ",
            schema: schema.ImportFormat,
            accept: [".xlsx", ".xls"],
            replace: false,
          },
        },

        buttons: {
          inline: [
            { icon: "edit", func: "Edit", caption: "Edit", reqFunc: "Edit" },
            { icon: "info", func: "Info", caption: "Details" },
          ],
          inlineOpposite: [{ icon: "delete", func: "Delete", caption: "Delete", reqFunc: "Delete" }],
          left: [{ icon: "add", func: "Add", caption: "Add Answer", reqFunc: "Add" }],
          right: [
            { icon: "deletebulk", func: "DeleteBulk", caption: (n) => "Delete (" + n + ")", reqFunc: "Delete", theme: "caution" },
            { icon: "export", func: "Export", caption: (n) => "Export (" + (n === 0 ? "All" : n) + ")", reqFunc: "Export" },
            { icon: "import", func: "Import", caption: "Import", reqFunc: "Import" },
          ],
        },
      },
    };
  }

  componentDidMount() {
    Authority.Require("Answer");
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(Answer.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  _renderTabSeletor = (Tab, handleTabChange) => {
    return (
      <HStack width="auto" gap="2px">
        <Button
          variant={Tab === "FAQ" ? "contained" : "outlined"}
          key={"0"}
          onClick={() => {
            handleTabChange("FAQ");
          }}
        >
          FAQ
        </Button>
        <Button
          variant={Tab === "FLE" ? "contained" : "outlined"}
          key={"1"}
          onClick={() => {
            handleTabChange("FLE");
          }}
        >
          FLE
        </Button>
        <Button
          variant={Tab === "EMOJI" ? "contained" : "outlined"}
          key={"2"}
          onClick={() => {
            handleTabChange("EMOJI");
          }}
        >
          Emoji
        </Button>
        <Button
          variant={Tab === "SYSTEM" ? "contained" : "outlined"}
          key={"2"}
          onClick={() => {
            handleTabChange("SYSTEM");
          }}
        >
          System
        </Button>
      </HStack>
    );
  };

  _filterDataByTab = (Tab, data) => {
    let filteredData = [];
    switch (Tab) {
      case "FAQ":
        filteredData = data.filter((obj) => obj.name.startsWith("FAQ"));
        break;
      case "FLE":
        filteredData = data.filter((obj) => obj.name.startsWith("Context_Action"));
        break;
      case "EMOJI":
        filteredData = data.filter((obj) => obj.name.startsWith("Emoji"));
        break;
      case "SYSTEM":
        filteredData = data.filter((obj) => !obj.name.startsWith("Context_Action") && !obj.name.startsWith("FAQ") && !obj.name.startsWith("Emoji"));
        break;
      default:
        filteredData = data;
        break;
    }
    return filteredData;
  };

  render() {
    let { base, serverSidePagination, title } = this.state;
    return (
      <VStack>
        <Box padding={1} width="100%">
          <Typography
            style={{
              textAlign: "left",
              width: "100%",
              fontSize: 25,
              color: ColorX.GetColorCSS("Primary"),
            }}
          >
            {title}
          </Typography>
        </Box>
        <Datumizo base={base} serverSidePagination={serverSidePagination} tabValue="FAQ" renderCustomTab={this._renderTabSeletor} filterDataByTab={this._filterDataByTab} />
      </VStack>
    );
  }
}

export default Answer;
